// extracted by mini-css-extract-plugin
module.exports = {"poweredCon":"style_poweredCon__16pYA","text":"style_text__t2f2r","poweredImg":"style_poweredImg__yTEW1"};